<div class="close-button" (click)="close()" *ngIf="!hidden">
  <div class="close-container">
    <div class="leftright"></div>
    <div class="rightleft"></div>
  </div>
</div>
